// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application,.v-application .body-1,.v-application .body-2,.v-application .caption,.v-application .display-1,.v-application .display-2,.v-application .display-3,.v-application .display-4,.v-application .headline,.v-application .overline,.v-application .subtitle-1,.v-application .subtitle-2,.v-application .title{font-family:Rubik,sans-serif!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
